










import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { State, Action, namespace, Mutation } from 'vuex-class'
import { YKDHeader } from 'ykd-components'
import 'normalize.css'

const ModuleUser = namespace('app-sandwich/user')

@Component({
  components: {
    YKDHeader,
  },
})
export default class WrapYKDHeader extends Vue {
  @ModuleUser.State((state) => state.isLogin)
  private isLogin!: boolean
  @Prop({ type: Boolean, default: false })
  needJudgeLogin?: boolean

  private onSearch(url: string) {
    this.$router.push(url)
  }

  get menuListMed() {
    if (this.isLogin) {
      return [
        ...this.menuListM,
        {
          title: '购物车',
          url: '/home_m/cart',
          target: '_self',
        },
      ]
    } else {
      return this.menuListM
    }
  }

  private menuList: MenuItem[] = [
    {
      title: '首页',
      url: '/',
      target: '_self',
    },
    {
      title: '学院',
      url: '/home_m/college',
      target: '_self',
    },
    {
      title: '就业班',
      url: '/home_m/fasttrack',
      target: '_self',
    },
    {
      title: 'Ucode',
      url: '/ucode/index',
      target: '_self',
    },
    // {
    //   title: 'App 下载',
    //   url: 'https://www.youkeda.com/app',
    //   target: '_self'
    // }
  ]

  private menuListM: MenuItem[] = [
    {
      title: '首页',
      url: '/',
      target: '_self',
    },
    {
      title: '学院',
      url: '/home_m/college',
      target: '_self',
    },
    {
      title: '就业班',
      url: '/home_m/fasttrack',
      target: '_self',
    },
    {
      title: 'Ucode',
      url: '/ucode/index',
      target: '_self',
    },
    // {
    //   title: 'App 下载',
    //   url: '/home_m/app',
    //   target: '_self'
    // }
  ]
}

interface MenuItem {
  title: string
  url: string
  target: string
  focus?: boolean
}
